import { Component, OnInit } from '@angular/core';
import { InspectionEquipmentService } from '../../service/inspection-equipment/inspection-equipment.service';
import { InspectionEquipment } from '../../class/inspection-equipment';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';

@Component({
  selector: 'app-inspection-equipments',
  templateUrl: './inspection-equipments.component.html',
  styleUrls: ['./inspection-equipments.component.scss']
})
export class InspectionEquipmentsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public inspectionEquipments: InspectionEquipment[];
    public selectInspectionEquipment: InspectionEquipment;
    public inspectionEquipmentID: Number = 0;
    public modNew = false;
    public modView = false;
    public openInspectionEquipment = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public inspectionEquipmentService: InspectionEquipmentService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService) { }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        //this.getInspectionEquipments();
    }

    public loadInspectionEquipmentsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getInspectionEquipments(event.globalFilter);
    }

    public getInspectionEquipments(query?: string) {
        this.inspectionEquipmentService.getInspectionEquipment(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.inspectionEquipments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newInspectionEquipment() {
        this.modNew = !this.modNew;
        this.selectInspectionEquipment = null;
    }

    public savedInspectionEquipment(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectInspectionEquipment = null;
        this.modNew = false;
        this.getInspectionEquipments();
    }

    public cancelInspectionEquipment (res) {
        this.selectInspectionEquipment = null;
        this.modNew = false;
        this.modView = false;
        this.getInspectionEquipments();
    }

    public edit(inspectionEquipment: InspectionEquipment) {
        this.modNew = true;
        this.selectInspectionEquipment = inspectionEquipment;
        this.getInspectionEquipments();
    }

    public view(inspectionEquipment: InspectionEquipment) {
        this.openInspectionEquipment = true;
        this.selectInspectionEquipment = inspectionEquipment;
        this.inspectionEquipmentID = inspectionEquipment.id;
        this.modView = true;
    }

    public deleteDialog(inspectionEquipment: InspectionEquipment) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(inspectionEquipment);
            }
        });
    }

    public delete(inspectionEquipment: InspectionEquipment) {
        this.inspectionEquipmentService.deleteInspectionEquipment(inspectionEquipment.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getInspectionEquipments();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeInspectionEquipment(inspectionEquipment: InspectionEquipment) {
        this.putInspectionEquipment(inspectionEquipment);
    }

    public hasPermission(permission) {
      return this.hasPermissionService.hasPermission(permission);
    }

    public putInspectionEquipment(values: InspectionEquipment) {
        const param = {
            // 'activated': values.activated
        };
        if (values) {
            const promise = this.inspectionEquipmentService.updateInspectionEquipment(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspection-equipments/inspection-equipments.component.ts